import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';

class TrainingStaffDisapprovedResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: this.props.hours,
      result: this.props.result,
      status_str: this.props.status_str,
      status: 0,
      confirmed: 0,
    };

    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        status_str: newProps.status_str,
        result: newProps.result,
        confirmed: newProps.confirmed,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Nota}</th>
              <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Horas}</th>
              <th className="text-center" width="236">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Status}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {this.state.result}
              </td>
              <td>
                { this.state.confirmed !== 0 ? this.state.hours : '' }
              </td>
              <td>
                {this.state.confirmed === 0 ?
                  <span className="label label-warning">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Faltante}</span>
                  :
                  <span className="label label-danger">{this.state.status_str}</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default TrainingStaffDisapprovedResult;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffDisapprovedResult.js